'use strict';

const mobileCheck = require('bunsen/helpers/mobileCheck');

const React = require('react');
const ReactDOM = require('react-dom');
const provideContext = require('fluxible-addons-react/provideContext');
const connectToStores = require('fluxible-addons-react/connectToStores');
const GlobalContextBaseView = require('../../global/reactHelpers/GlobalContextBaseView');

// Stores
const GalleryStore = require('../stores/GalleryStore');
const GalleryPhotoUIStore = require('../stores/GalleryPhotoUIStore');
const CategoriesStore = require('../../global/stores/CategoriesStore');
const CreatorsStore = require('../../global/stores/CreatorsStore');

// Actions
const galleryActions = require('../actions/galleryActions');
const galleryPhotoUIActions = require('../actions/galleryPhotoUIActions');
const galleryTrackingActions = require('../actions/galleryTrackingActions');

const constants = require('../helpers/GalleryConstants');
const { galleryPhotoWrapper } = constants.galleryPhotoClasses;
const { NEXT, PREVIOUS } = constants.switchActions;

// Connected Gallery Photo React Component
const GalleryPhotoWrapperConnected = provideContext(
    connectToStores(
        require('../components/GalleryPhotoWrapper'),
        [GalleryStore, GalleryPhotoUIStore, CategoriesStore, CreatorsStore],
        context => {
            const galleryStore = context.getStore(GalleryStore);
            const categoriesStore = context.getStore(CategoriesStore);
            const galleryUIStore = context.getStore(GalleryPhotoUIStore);
            const creatorsStore = context.getStore(CreatorsStore);

            return {
                itemTagsState: galleryUIStore.getItemTagsState(),
                photoData: {
                    /* For GalleryPhotoItemTags.jsx */
                    photoId: galleryStore.getCurrentPhotoId(),
                    photoSrc: galleryStore.getCurrentPhotoSrc(),
                    photoAlt: galleryStore.getCurrentPhotoAlt(),
                    photoIndex: galleryStore.getCurrentPhotoIndex(),
                    totalPhotos: galleryStore.getTotalNumberOfPhotos(),

                    /* For GalleryPhotoImage.jsx */
                    itemTags: galleryStore.getCurrentPhotoItemTags(),
                    creatorsMap: creatorsStore.getCreatorsMap(),
                    categoriesMap: categoriesStore.getCategoriesMap(),
                    imageDimensions: galleryUIStore.getImageDimensions(),
                    similarItemsUrls: galleryStore.getSimilarItemsUrls(),
                },
            };
        }
    )
);

const GalleryPhotoWrapper = GlobalContextBaseView.extend({
    el: `.${galleryPhotoWrapper}`,

    initialize({ context, pageType }) {
        ReactDOM.render(
            React.createElement(GalleryPhotoWrapperConnected, {
                context: context.getComponentContext(),
                allowTouchEvents: mobileCheck.any(),
                handlers: {
                    next: () =>
                        context.executeAction(galleryActions.switchPhoto, {
                            action: NEXT,
                            pageType,
                        }),
                    prev: () =>
                        context.executeAction(galleryActions.switchPhoto, {
                            action: PREVIOUS,
                            pageType,
                        }),
                    zoomIn: () => context.executeAction(galleryTrackingActions.trackMobileZoom),
                },
                updateImageDimensions: payload =>
                    context.executeAction(galleryPhotoUIActions.updateImageDimensions, payload),
                showItemTagIndicators: payload =>
                    context.executeAction(galleryPhotoUIActions.showItemTagIndicators, payload),
                hideItemTagIndicators: payload =>
                    context.executeAction(galleryPhotoUIActions.hideItemTagIndicators, payload),
                showItemTagTooltip: payload =>
                    context.executeAction(galleryPhotoUIActions.showItemTagTooltip, payload),
                hideItemTagTooltip: payload =>
                    context.executeAction(galleryPhotoUIActions.hideItemTagTooltip, payload),
                trackLinkClick: payload =>
                    context.executeAction(galleryTrackingActions.trackLinkClick, payload),
                sharePhoto: payload => context.executeAction(galleryActions.sharePhoto, payload),
            }),
            this.el
        );
    },
});

module.exports = GalleryPhotoWrapper;



// WEBPACK FOOTER //
// ./assets/js/gallery/views/GalleryPhotoWrapper.es.js